import { Popover, Space, Table, Tooltip } from "antd";
// import moment from "moment";
import { useState, useEffect } from "react";
// import { getApi } from "redux/apis";
import { pageSizeOptionsPaging } from "utils/constant";
import { SortSvgBottom, SortSvgTop } from "utils/svgs";
// import { invalidText, toastText } from "utils/utils";
import SearchAndFilter from "../SearchAndFilter";
import styles from "./index.module.scss";
import { EditOutlined, ExportOutlined, EyeOutlined } from "@ant-design/icons";
import InventoryDetailsModal from "../InventoryDetailsModal";
import DropdownComponent from "components/InventoryControl/Inventory/InventoryTable/Dropdown";
import { getApi } from "redux/apis";
// import Ellipse from "components/Global/Ellipse";

const { Column } = Table;

interface Props {
  allInventoryData: any[];
  isLoading: boolean;
  onEdit: (inventoryData: any) => void;
  currentPage: number;
  pageSize: number;
  totalRecords: number;
  tableChangeHandler: (pagination: any, filters: any, sorter: any) => void;
  isServiceCenter: boolean;
  isEmployee: boolean;
  searchValue: string;
  performSearchHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchFields: string[];
  handleOk: any;
  handleServiceCenterChange: any;
  selectedServiceCenter: any;
  handleSparePartsChange: any;
  selectedSpareParts: any;
  fetchInventory: any;
  handleFromDateChange: any;
  handleToDateChange: any;
  fromDate: any;
  toDate: any;
  handleSalesOrderNumberChange: any;
  selectedSalesOrderNumbers: any;
  isAdmin?: any;
  sortDirection: any;
  handleStatusChange: any;
  selectedStatus: any;
  expandedRowKeys: any;
  expandedDetails: any;
  expandedPages: any;
  setExpandedRowKeys: any;
  setExpandedDetails: any;
  setExpandedPages: any;
  setFiltersReset: any;
  statusUpdated: any;
  statusstateSetter?: (data: boolean) => void;
  rowSelection?: any;
  selectedRowKeys?: string[];
  handleDeleteClick?: () => void;
  canDelete?: boolean;
}

const SortingIcon = (data: any) => {
  return data.data.sortOrder === "ascend" ? <SortSvgTop /> : <SortSvgBottom />;
};

const InventoryTable = (props: Props) => {
  const {
    allInventoryData,
    isLoading,
    onEdit,
    currentPage,
    pageSize,
    totalRecords,
    tableChangeHandler,
    isServiceCenter,
    isEmployee,
    searchValue,
    performSearchHandler,
    searchFields,
    handleOk,
    handleServiceCenterChange,
    selectedServiceCenter,
    handleSparePartsChange,
    selectedSpareParts,
    handleFromDateChange,
    handleToDateChange,
    fromDate,
    toDate,
    fetchInventory,
    handleSalesOrderNumberChange,
    selectedSalesOrderNumbers,
    isAdmin,
    sortDirection,
    handleStatusChange,
    selectedStatus,
    expandedRowKeys,
    // expandedDetails,
    // expandedPages,
    // setExpandedRowKeys,
    setExpandedDetails,
    setExpandedPages,
    setFiltersReset,
    statusUpdated,
    statusstateSetter,
    rowSelection,
    selectedRowKeys,
    handleDeleteClick,
    canDelete = false,
  } = props;
  console.log("aaaaaa", selectedServiceCenter);
  // const [expandedLoading, setExpandedLoading] = useState<
  //   Record<string, boolean>
  // >({});

  // Add state for child table sorting
  // const [childTableSorting, setChildTableSorting] = useState<{
  //   columnKey: string;
  //   order: 'ascend' | 'descend' | undefined;
  // }>({
  //   columnKey: '',
  //   order: undefined
  // });

  // Track if we need to fetch more data for each expanded row
  // const [canFetchMore, setCanFetchMore] = useState<Record<string, boolean>>({});

  const [modalVisible, setModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>(null);

  const [serviceCenters, setServiceCenters] = useState([]);

  useEffect(() => {
    const fetchServiceCenters = async () => {
      try {
        const response = await getApi("/serviceCenter/shipment-dropdown");
        if (response.data.success) {
          const formattedCenters = response.data.data.map((center: any) => ({
            value: center.id,
            label: center.name,
          }));
          setServiceCenters(formattedCenters);
        }
      } catch (error) {
        console.error("Failed to fetch service centers:", error);
      }
    };

    fetchServiceCenters();
  }, []);
  // Effect to clean up expanded details when selection changes
  useEffect(() => {
    if (expandedRowKeys.length === 0) {
      setExpandedDetails({});
      setExpandedPages({});
      // setCanFetchMore({});
    }
  }, [expandedRowKeys, setExpandedDetails, setExpandedPages]);

  // const fetchMoreData = async (record: any, sorter?: any, resetData = false) => {
  //   try {
  //     const recordId = record.id;

  //     setExpandedLoading((prev) => ({ ...prev, [recordId]: true }));

  //     // Set the current page - if resetting, start from page 1
  //     const currentPage = resetData ? 1 : expandedPages[recordId] || 1;

  //     // Build query with sorting parameters if provided
  //     const query: any = {
  //       page: currentPage,
  //       pageSize: 10,
  //       serviceCenterId: record.serviceCenterId,
  //       salesOrderNumber: [record.salesOrderNumber],
  //       itemNumber: [record.itemNumber],
  //       status: selectedStatus,
  //     };

  //     // Add sorting to the query if sorter is provided
  //     if (sorter?.columnKey && sorter?.order) {
  //       query.sortBy = sorter.columnKey;
  //       query.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc';
  //     }

  //     const response = await getApi("/inventory", query);
  //     const newDetails = response.data.data.data;
  //     const totalItems = response.data.data.total || 0;

  //     // Determine if there are more pages to fetch
  //     const hasMoreData = currentPage * 10 < totalItems;
  //     setCanFetchMore((prev) => ({ ...prev, [recordId]: hasMoreData }));

  //     if (resetData || currentPage === 1) {
  //       // Replace existing data if resetting or it's the first page
  //       setExpandedDetails((prev: any) => ({
  //         ...prev,
  //         [recordId]: newDetails,
  //       }));
  //     } else {
  //       // Append data for subsequent pages
  //       setExpandedDetails((prev: any) => ({
  //         ...prev,
  //         [recordId]: [...(prev[recordId] || []), ...newDetails],
  //       }));
  //     }

  //     // Update the page counter for next fetch
  //     setExpandedPages((prev: any) => ({
  //       ...prev,
  //       [recordId]: currentPage + 1,
  //     }));
  //   } catch (error: any) {
  //     const errorMessage =
  //       error.response?.data?.error?.message ||
  //       "Failed to fetch detailed inventory";
  //     toastText(errorMessage, "error");
  //     // Set canFetchMore to false on error
  //     setCanFetchMore((prev) => ({ ...prev, [record.id]: false }));
  //   } finally {
  //     setExpandedLoading((prev) => ({ ...prev, [record.id]: false }));
  //   }
  // };

  // Handle sorting change in the child table
  // const handleChildTableChange = (pagination: any, filters: any, sorter: any, record: any) => {
  //   // Only process if the sorting actually changed
  //   if (sorter.columnKey !== childTableSorting.columnKey ||
  //       sorter.order !== childTableSorting.order) {

  //     // Update the child table sorting state
  //     setChildTableSorting({
  //       columnKey: sorter.columnKey,
  //       order: sorter.order
  //     });

  //     // Fetch data with the new sorting parameters and reset existing data
  //     fetchMoreData(record, sorter, true);
  //   }
  // };

  // const expandedRowRender = (record: any) => {
  //   const details = expandedDetails[record.id] || [];
  //   const loading = expandedLoading[record.id] || false;

  //   return (
  //     <Table
  //       dataSource={details}
  //       pagination={false}
  //       className="bg-white"
  //       style={{ width: "100%", padding: "1.5rem 0px" }}
  //       scroll={{ y: 300 }}
  //       loading={loading}
  //       onChange={(pagination, filters, sorter) => handleChildTableChange(pagination, filters, sorter, record)}
  //       onScroll={(e: any) => {
  //         const { scrollTop, scrollHeight, clientHeight } = e.target;
  //         // Check if scrolled to bottom and more data can be fetched
  //         if (
  //           Math.abs(scrollHeight - scrollTop - clientHeight) <= 1 &&
  //           !loading &&
  //           canFetchMore[record.id]
  //         ) {
  //           // Include current sorting when fetching more data on scroll
  //           fetchMoreData(record, childTableSorting.columnKey ?
  //             { columnKey: childTableSorting.columnKey, order: childTableSorting.order } :
  //             undefined);
  //         }
  //       }}
  //     >
  //       {/* <Column
  //         title="Service Center"
  //         dataIndex="serviceCenter"
  //         key="serviceCenter"
  //         className="bg-white"
  //         width={"16%"}
  //         render={(text: string) => {
  //           if (text && text.length > 20) {
  //             return (
  //               <Popover
  //                 content={text}
  //                 trigger="hover"
  //                 placement="top"
  //                 getPopupContainer={(triggerNode) =>
  //                   triggerNode.parentElement || document.body
  //                 }
  //               >
  //                 <span>{text.slice(0, 20)}...</span>
  //               </Popover>
  //             );
  //           }
  //           return text;
  //         }}
  //       />
  //       <Column
  //         title="3nStar Sales Order"
  //         dataIndex="salesOrderNumber"
  //         key="salesOrderNumber"
  //         className="bg-white"
  //         width={"20%"}
  //       /> */}
  //       <Column
  //         title="Item"
  //         dataIndex="itemNumber"
  //         key="itemNumber"
  //         className="bg-white"
  //         width={"15%"}
  //         // showSorterTooltip={{ title: "" }}
  //         // defaultSortOrder={sortDirection}
  //         // sorter={() => {
  //         //   return null as any;
  //         // }}
  //         // sortDirections={["ascend", "descend", "ascend"]}
  //         // sortIcon={(data) => <SortingIcon data={data} />}
  //         sortDirections={["ascend", "descend", "ascend"]}
  //         sortIcon={(data) => <SortingIcon data={data} />}
  //       />
  //       <Column
  //         title="Item Description"
  //         dataIndex="itemDescription"
  //         key="itemDescription"
  //         className="bg-white"
  //         width={"25%"}
  //         render={(text: string) => {
  //           if (invalidText(text)) return "-";
  //           if (text && text.length > 30) {
  //             return (
  //               <Popover
  //                 content={text}
  //                 trigger="hover"
  //                 destroyTooltipOnHide
  //                 mouseLeaveDelay={0.1}
  //               >
  //                 <span>{text.slice(0, 30)}...</span>
  //               </Popover>
  //             );
  //           }
  //           return text;
  //         }}
  //       />
  //       <Column
  //         title="Arrival Date"
  //         dataIndex="arrivalDate"
  //         key="arrivalDate"
  //         className="bg-white"
  //         width={"15%"}
  //         showSorterTooltip={{ title: "" }}
  //         sortDirections={["ascend", "descend", "ascend"]}
  //         sortIcon={(data) => <SortingIcon data={data} />}
  //         sorter={true}
  //         render={(text) => (text ? moment(text).format("MM/DD/YYYY") : "-")}
  //       />
  //       <Column
  //         title="Status"
  //         dataIndex="status"
  //         key="status"
  //         className="bg-white"
  //         width={"15%"}
  //         render={(status: string) => {
  //           const statusColorMap: Record<string, string> = {
  //             IN_TRANSIT: "blue",
  //             RECEIVED: "green",
  //             LOST: "yellow",
  //             DAMAGED: "red",
  //           };
  //           const formattedStatus = status
  //             .replace(/_/g, " ")
  //             .toLowerCase()
  //             .replace(/\b\w/g, (char) => char.toUpperCase());

  //           return (
  //             <Tag color={statusColorMap[status] || "default"}>
  //               {formattedStatus}
  //             </Tag>
  //           );
  //         }}
  //       />
  //       <Column
  //         title="Actions"
  //         dataIndex="action"
  //         key="action"
  //         className="bg-white"
  //         width={"10%"}
  //         render={(values: any, data: any) => {
  //           const isEditable =
  //             !isEmployee && (isAdmin || data.status === "IN_TRANSIT");

  //           return (
  //             <Space size={20}>
  //               {isEditable ? (
  //                 <div
  //                   className="cursor-pointer flex align-center justify-center"
  //                   onClick={() => onEdit(data)}
  //                   style={{ marginRight: "2rem" }}
  //                 >
  //                   <EditActionSvg />
  //                 </div>
  //               ) : (
  //                 <div
  //                   className="flex align-center justify-center"
  //                   style={{
  //                     marginRight: "2rem",
  //                     opacity: 0.3,
  //                     cursor: "not-allowed",
  //                   }}
  //                 >
  //                   <EditActionSvg />
  //                 </div>
  //               )}
  //             </Space>
  //           );
  //         }}
  //       />
  //     </Table>
  //   );
  // };
  console.log("asdhas", selectedServiceCenter);

  return (
    <div className={styles["inventory-table__wrapper"]}>
      <div className={styles["dropdown__wrapper"]}>
        <DropdownComponent
          options={
            serviceCenters.length > 1
              ? [{ value: "all", label: "All" }, ...serviceCenters]
              : serviceCenters
          }
          placeholder="Select Service Center"
          value={
            serviceCenters.length === 0
              ? []
              : serviceCenters.length === 1
              ? [serviceCenters[0].value]
              : selectedServiceCenter && Array.isArray(selectedServiceCenter)
              ? selectedServiceCenter
              : []
          }
          onChange={handleServiceCenterChange}
          isLoading={isLoading}
        />
      </div>
      <SearchAndFilter
        performSearchHandler={performSearchHandler}
        searchValue={searchValue}
        searchFields={searchFields}
        isServiceCenter={isServiceCenter}
        handleServiceCenterChange={handleServiceCenterChange}
        selectedServiceCenter={selectedServiceCenter}
        handleSparePartsChange={handleSparePartsChange}
        selectedSpareParts={selectedSpareParts}
        handleFromDateChange={handleFromDateChange}
        handleToDateChange={handleToDateChange}
        onApply={handleOk}
        fromDate={fromDate}
        toDate={toDate}
        handleSalesOrderNumberChange={handleSalesOrderNumberChange}
        selectedSalesOrderNumbers={selectedSalesOrderNumbers}
        fetchInventory={fetchInventory}
        handleStatusChange={handleStatusChange}
        selectedStatus={selectedStatus}
        setFiltersReset={setFiltersReset}
        handleDeleteClick={handleDeleteClick}
        selectedRowKeys={selectedRowKeys}
        canDelete={canDelete}
      />
      <Table
        dataSource={allInventoryData}
        rowKey={(record) => record.itemNumber}
        loading={isLoading}
        scroll={{ y: "calc(100vh - 490px)", x: "63vh" }}
        onChange={tableChangeHandler}
        rowSelection={rowSelection}
        // expandable={{
        //   expandedRowRender,
        //   expandedRowKeys,
        //   onExpand: (expanded, record) => {
        //     const newKeys = expanded
        //       ? [record.id]
        //       : expandedRowKeys.filter((key: any) => key !== record.id);

        //     setExpandedRowKeys(newKeys);

        //     if (expanded) {
        //       // Always fetch data when expanding a row
        //       fetchMoreData(record, undefined, true);
        //     }
        //   },
        // }}
        pagination={{
          total: totalRecords,
          current: currentPage,
          pageSize: pageSize,
          pageSizeOptions: pageSizeOptionsPaging,
          showSizeChanger: true,
        }}
        className={styles["inventory-table"]}
      >
        {/* <Column
          title="Service Center"
          dataIndex="serviceCenter"
          key="serviceCenter"
          className="bg-white"
          width={"30%"}
          showSorterTooltip={{ title: "" }}
          defaultSortOrder={sortDirection}
          sorter={() => {
            return null as any;
          }}
          sortDirections={["ascend", "descend", "ascend"]}
          sortIcon={(data) => <SortingIcon data={data} />}
          render={(text: string) => {
            if (text && text.length > 20) {
              return (
                <Popover
                  content={text}
                  trigger="hover"
                  destroyTooltipOnHide
                  mouseLeaveDelay={0.1}
                >
                  <span>{text.slice(0, 20)}...</span>
                </Popover>
              );
            }
            return text;
          }}
        />
        <Column
          title="3nStar Sales Order"
          dataIndex="salesOrderNumber"
          key="salesOrderNumber"
          className="bg-white"
          width={"25%"}
          showSorterTooltip={{ title: "" }}
          defaultSortOrder={sortDirection}
          sorter={() => {
            return null as any;
          }}
          sortDirections={["ascend", "descend", "ascend"]}
          sortIcon={(data) => <SortingIcon data={data} />}
        /> */}
        <Column
          title="Item#"
          dataIndex="itemNumber"
          key="itemNumber"
          className="bg-white"
          width={"25%"}
          showSorterTooltip={{ title: "" }}
          defaultSortOrder={sortDirection}
          sorter={() => {
            return null as any;
          }}
          sortDirections={["ascend", "descend", "ascend"]}
          sortIcon={(data) => <SortingIcon data={data} />}
        />

        <Column
          title="Description"
          dataIndex="description"
          key="description"
          className="bg-white"
          width={"35%"}
          showSorterTooltip={{ title: "" }}
          render={(text: string) => (
            <Tooltip title={text}>
              {text?.length > 50 ? `${text.slice(0, 50)}...` : text}
            </Tooltip>
          )}
        />

        <Column
          title="Quantity"
          dataIndex="totalQuantity"
          key="totalQuantity"
          className="bg-white"
          width={"25%"}
        />

        <Column
          title="Actions"
          key="actions"
          className="bg-white"
          width={"10%"}
          render={(record: any) => {
            console.log("record", allInventoryData);

            // Logic to determine if edit action is enabled

            return (
              <Space size={20}>
                <div
                  className="cursor-pointer flex align-center justify-center"
                  onClick={() => {
                    setCurrentRecord(record);
                    setModalVisible(true);
                  }}
                >
                  <EyeOutlined
                    style={{ fontSize: "22px" }}
                    className="eyeIcon"
                  />
                </div>
              </Space>
            );
          }}
        />
      </Table>

      <InventoryDetailsModal
        visible={modalVisible}
        itemStatus={selectedStatus}
        onClose={() => setModalVisible(false)}
        record={currentRecord}
        onEdit={onEdit}
        isAdmin={isAdmin}
        isEmployee={isEmployee}
        fetchInventory={fetchInventory}
        statusUpdated={statusUpdated}
        statusstateSetter={statusstateSetter}
        selectedServiceCenter={
          serviceCenters.length === 1
            ? serviceCenters[0].value
            : selectedServiceCenter
        }
      />
    </div>
  );
};

export default InventoryTable;
